import localforage from 'localforage';
import { StorageConstants } from '@linkie/shared';

export const migrateToIndexedDB = async () => {
  const stores = [StorageConstants.PLAYGROUND_STORE, StorageConstants.IDENTITY];

  for (const key of stores) {
    try {
      const existing = await localforage.getItem(key);
      if (existing) continue;

      const oldData = localStorage.getItem(key);
      if (!oldData) continue;

      const parsed = JSON.parse(oldData);
      await localforage.setItem(key, parsed);

      localStorage.removeItem(key);

      console.log(`[Migration] ${key} successfully migrated to IndexedDB`);
    } catch (err) {
      console.error(`[Migration] Failed to migrate ${key}`, err);
    }
  }
};
